"use client"
import React from 'react'
import styles from './back-button.module.scss'
import SvgArrowLeft from '@/src/assets/svgs/collection/arrow-left-full.svg'
import { useRouter } from 'next/navigation'

type Theme = 'primary' | 'inverted'

interface Props {
    onClick?: () => void
    className?: string
    theme?: Theme
}

export default function BackButton(props: Props) {
    const router = useRouter()
    return (
        <div
            onClick={() => props.onClick ? props.onClick() : router.push('/')}
            className={`${styles.close} ${props.className ?? ""} ${props.theme === 'primary' || props.theme === undefined ? styles.primary : styles.inverted}`}>
            <SvgArrowLeft className={styles.closeSvg} />
        </div>
    )
}
